var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"modal-ver-imagen"},[_c('modal',{ref:"ver_archivo",attrs:{"titulo":"","tamano":"modal-xl"}},[_c('div',{staticClass:"row mx-0 my-3 justify-center",attrs:{"oncontextmenu":"return false","onkeydown":"return false"}},[_c('img',{staticClass:"imagen m-auto",attrs:{"src":_vm.ruta,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }